import { render } from "./workflowManagement.vue?vue&type=template&id=7d766980&scoped=true"
import script from "./workflowManagement.vue?vue&type=script&lang=js"
export * from "./workflowManagement.vue?vue&type=script&lang=js"

import "./workflowManagement.vue?vue&type=style&index=0&id=7d766980&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d766980"]])

export default __exports__